import { render, staticRenderFns } from "./OpenNewTabDeposits.vue?vue&type=template&id=05b30d9d&scoped=true"
import script from "./OpenNewTabDeposits.vue?vue&type=script&lang=js"
export * from "./OpenNewTabDeposits.vue?vue&type=script&lang=js"
import style0 from "./OpenNewTabDeposits.vue?vue&type=style&index=0&id=05b30d9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b30d9d",
  null
  
)

export default component.exports